import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { apiClient } from "@/lib/apiClient";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [debugToken, setDebugToken] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");
    setError("");
    setDebugToken("");
    try {
      const res = await apiClient.post("/auth/forgot-password", { email });
      setMessage(res.data?.message || "Wenn ein Konto existiert, wurde ein Reset-Link verschickt.");
      if (res.data?.reset_token) {
        setDebugToken(res.data.reset_token);
      }
    } catch (err) {
      console.error(err);
      setError("Es ist ein Fehler aufgetreten.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="forgot-password-page">
      <Card className="w-full max-w-md p-6 border border-slate-200 shadow-sm bg-white">
        <h1 className="text-2xl font-semibold text-slate-900 mb-2">Passwort vergessen</h1>
        <p className="text-sm text-slate-500 mb-4">
          Geben Sie Ihre E-Mail-Adresse ein. Wenn ein Konto existiert, können Sie Ihr Passwort zurücksetzen.
        </p>

        {message && (
          <div className="mb-3 rounded-md border border-emerald-200 bg-emerald-50 px-3 py-2 text-xs text-emerald-800">
            {message}
          </div>
        )}
        {error && (
          <div className="mb-3 rounded-md border border-rose-200 bg-rose-50 px-3 py-2 text-xs text-rose-800">
            {error}
          </div>
        )}

        <form className="space-y-3" onSubmit={handleSubmit} data-testid="forgot-password-form">
          <div className="space-y-1">
            <Label htmlFor="email">E-Mail</Label>
            <Input
              id="email"
              type="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="forgot-password-email-input"
            />
          </div>
          <div className="flex justify-between items-center text-xs text-slate-500">
            <Link to="/login" className="hover:underline" data-testid="forgot-password-back-to-login-link">
              Zurück zur Anmeldung
            </Link>
          </div>
          <div className="flex justify-end">
            <Button
              type="submit"
              size="sm"
              className="rounded-full bg-slate-900 text-slate-50 px-4"
              disabled={loading}
              data-testid="forgot-password-submit-button"
            >
              {loading ? "Sende Anweisungen ..." : "Link senden"}
            </Button>
          </div>
        </form>

        {debugToken && (
          <div className="mt-4 p-2 border border-dashed border-slate-300 rounded text-xs text-slate-500">
            <div className="font-semibold mb-1">Debug-Token (nur Entwicklung):</div>
            <code className="break-all" data-testid="forgot-password-debug-token">{debugToken}</code>
          </div>
        )}
      </Card>
    </div>
  );
}
